import React from "react";
import { liheart } from "../../../assets/icons";
import { PublicService } from "../../../services";
import { useQuery } from "@tanstack/react-query";
import {
  menopauseBannerLeft,
  menopauseBannerRight,
} from "../../../assets/images";
import { Link } from "react-router-dom";
import FAQ from "../../home/section/FAQ";
import { Helmet } from "react-helmet";

const Menopause = ({ type }) => {
  const schemaData =   {
 "@context": "https://schema.org",
 "@graph": [
   {
     "@type": "MedicalCondition",
     "name": "Menopause",
     "alternateName": "Menopause",
     "description": "Discover holistic menopause care at Holypills. Track symptoms via our app and consult expert homeopaths for personalized, natural, and side‑effect‑free relief.",
     "url": "https://holypills.in/menopause-symptoms-causes-treatment",
     "mainEntityOfPage": "https://holypills.in/menopause-symptoms-causes-treatment",
     "associatedAnatomy": {
       "@type": "AnatomicalStructure",
       "name": "Reproductive System"
     },
     "possibleTreatment": {
       "@type": "MedicalTherapy",
       "name": "Homeopathy"
     },
     "signOrSymptom": [
       { "@type": "MedicalSignOrSymptom", "name": "Irregular periods leading to eventual cessation" },
       { "@type": "MedicalSignOrSymptom", "name": "Hot flashes and sudden sweating" },
       { "@type": "MedicalSignOrSymptom", "name": "Sleep disturbances" },
       { "@type": "MedicalSignOrSymptom", "name": "Vaginal dryness causes discomfort during intercourse" },
       { "@type": "MedicalSignOrSymptom", "name": "Thinning hair and dry skin" },
       { "@type": "MedicalSignOrSymptom", "name": "Night sweats disrupting sleep" },
       { "@type": "MedicalSignOrSymptom", "name": "Mood swings, irritability, or anxiety" }
     ]
   }
 ]
};

  const faqData =  {
 "@context": "https://schema.org",
 "@type": "FAQPage",
 "mainEntity": [{
   "@type": "Question",
   "name": "Is menopause curable with homeopathy?",
   "acceptedAnswer": {
     "@type": "Answer",
     "text": "Menopause is a natural biological process, not a disease, so it cannot be 'cured.' However, menopause homeopathy treatment in India focuses on easing symptoms such as hot flashes, sleep issues, mood swings, and hormonal imbalance. With homeopathy and menopause care, women can find safe, non-hormonal relief that supports long-term health without side effects."
   }
 },{
   "@type": "Question",
   "name": "What is early or premature menopause?",
   "acceptedAnswer": {
     "@type": "Answer",
     "text": "Premature menopause occurs when periods stop before age 40, often due to hormonal imbalance, genetics, medical treatments, or underlying health conditions. It can lead to symptoms similar to natural menopause but may require medical attention. Consulting a homeopathic doctor for menopause India can help manage symptoms and reduce long-term risks."
   }
 },{
   "@type": "Question",
   "name": "How can your app help me during perimenopause?",
   "acceptedAnswer": {
     "@type": "Answer",
     "text": "The Holypills app can help you track perimenopause symptoms, lifestyle habits, and improvements over time. This app-based tracking, along with homeopathy and menopause treatment, ensures women stay in control of their health journey."
   }
 },{
   "@type": "Question",
   "name": "What makes homeopathy safe for menopause management?",
   "acceptedAnswer": {
     "@type": "Answer",
     "text": "Homeopathy uses natural remedies tailored to individual symptoms. It does not interfere with the body's natural processes and has no long-term side effects, making it safe and effective for most women."
   }
   }
 ]
};


  const { healthPage } = PublicService();

  const pcosQuery = useQuery({
    queryKey: ["menopause"],
    queryFn: () => healthPage({ category: "menopause" }),
  });

  const detail = pcosQuery?.data?.data?.content;

  return (
    <>
      <Helmet defer={false}>
        <title>
          Menopause Relief with Holypills: Personalized Homeopathy & App‑based
          Tracking
        </title>
        <meta
          name="description"
          content="Discover holistic menopause care at Holypills. Track symptoms via our app and consult expert homeopaths for personalized, natural, and side‑effect‑free relief."
        />
        <meta property="og:image" content="/src/assets/images/ogImage.jpg" />
        <meta name="twitter:image" content="/src/assets/images/ogImage.jpg" />
        <link
          rel="canonical"
          href="https://holypills.in/menopause-symptoms-causes-treatment"
        ></link>

        <meta property="og:type" content="article" />
        <meta
          property="og:title"
          content="Menopause Relief with Holypills: Personalized Homeopathy & App-based Tracking"
        />
        <meta
          property="og:description"
          content="Discover holistic menopause care at Holypills. Track symptoms via our app and consult expert homeopaths for personalized, natural, and side-effect-free relief."
        />

        <meta
          property="og:url"
          content="https://holypills.in/menopause-symptoms-causes-treatment"
        />
        <meta property="og:site_name" content="Holypills"></meta>

        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="Menopause Relief with Holypills: Personalized Homeopathy & App-based Tracking"
        />
        <meta
          name="twitter:description"
          content="Discover holistic menopause care at Holypills. Track symptoms via our app and consult expert homeopaths for personalized, natural, and side-effect-free relief."
        />
        <meta
          name="twitter:url"
          content="https://holypills.in/menopause-symptoms-causes-treatment"
        ></meta>

        <script type="application/ld+json">{JSON.stringify(schemaData)}</script>
        <script type="application/ld+json">{JSON.stringify(faqData)}</script>
      </Helmet>
      <div className="wrapper_pcos_page menopause">
        {/* <section className="wrap_pcos_banner">
        <figure>
          <img src={detail?.banner?.image} alt="" />
        </figure>
      </section> */}

        <section className="banner_sec">
          <div className="container">
            <div className="inner_part">
              <div className="left_part">
                <div className="left_image">
                  <figure>
                    <img src={menopauseBannerLeft} alt="banner-image" />
                  </figure>
                </div>
              </div>
              <div className="right_part">
                <div className="right_img">
                  <figure>
                    <img src={menopauseBannerRight} alt="banner-image" />
                  </figure>
                </div>
              </div>
              <div className="banner_content">
                <h1>
                  Menopause Relief with Holypills
                  <span>
                    Personalized Homeopathy Care Backed by AI-Powered App
                  </span>
                </h1>
                <p>
                  Menopause is a natural phase in every woman's life. It is a
                  natural transition caused by declining hormone levels, which
                  typically occurs between the ages of 45 and 55. Learn about
                  the symptoms, risk factors, and homeopathy treatment for
                  Menopause.
                </p>
                {/* <div className="btn-box">
                  <Link to="/login" className="button blue">
                    Book a Consultation Now!
                  </Link>
                </div> */}
              </div>
            </div>
          </div>
        </section>

        <section className="wrapper_pcos spacing">
          <div className="container">
            <div className="wraper_cards">
              <div className="wrap_left">
                <h2>{detail?.whatIsSection?.title}</h2>
                <p>{detail?.whatIsSection?.description}</p>
                <ul>
                  {detail?.whatIsSection?.benifits.map((item, index) => (
                    <li key={index}>
                      <img src={liheart} alt="heart-icon" />
                      <span>{item}</span>
                    </li>
                  ))}
                </ul>
              </div>
              <div className="wrap_right">
                <figure>
                  <img src={detail?.whatIsSection?.image} alt="section-image" />
                </figure>
              </div>
            </div>
          </div>
        </section>
        <section className="wrapper_Symptoms spacing">
          <div className="container">
            <div className="wrap_symptoms_card">
              <div className="page_title">
                <h2>{detail?.commonSigns?.title}</h2>
                <p>{detail?.commonSigns?.description}</p>
              </div>
              <div className="wrap_btn_card">
                {detail?.commonSigns?.signs.map((item, index) => (
                  <button key={index} className={index === 1 ? "" : ""}>
                    {item}
                  </button>
                ))}
              </div>
            </div>
          </div>
        </section>
        <section className="wrapper_pcos wrapper_what_cause spacing">
          <div className="container">
            <div className="wraper_cards">
              <div className="wrap_right">
                <figure>
                  <img src={detail?.causesSection?.image} alt="causes-image" />
                </figure>
              </div>
              <div className="wrap_left">
                <h2>{detail?.causesSection?.title}</h2>
                <p>{detail?.causesSection?.description}</p>
                {/* <p>
                Polycystic ovary syndrome (PCOS) is a problem with hormones that
                happens during the reproductive years. If you have PCOS, you may
                not have periods very often. Or you may have periods that last
                many days. You may also have too much of a hormone called
                androgen in your body.
              </p>
              <p>
                With PCOS, many small sacs of fluid develop along the outer edge
                of the ovary. These are called cysts. The small fluid-filled
                cysts contain immature eggs, called follicles. The follicles
                fail to regularly release eggs.
              </p> */}
                <ul>
                  {detail?.causesSection?.benifits.map((item, index) => (
                    <li key={index}>
                      <img src={liheart} alt="heart-icon" />
                      <div className="wrap_txt">
                        <p>{item?.title}</p>
                        <span>{item?.description}</span>
                      </div>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </section>
        <section className="wrapper_Symptoms wrapper_help spacing">
          <div className="container">
            <div className="wrap_symptoms_card">
              <div className="page_title">
                <h2>{detail?.howToManage?.title}</h2>
                <p>{detail?.howToManage?.description}</p>
              </div>
              <div className="wrap_btn_card">
                {detail?.howToManage?.features.map((item, index) => (
                  <button key={index}>
                    <img src={item?.image} alt="icon" />
                    <span>{item.title}</span>
                  </button>
                ))}
              </div>
            </div>
          </div>
        </section>
        <section className="wrapper_pcos wrapper_pcos_system spacing">
          <div className="container">
            <div className="wraper_cards">
              <div className="wrap_left">
                <h2>{detail?.howToReduce?.title}</h2>
                <p>{detail?.howToReduce?.description}</p>
                <ul>
                  {detail?.howToReduce?.benifits.map((item, index) => (
                    <li key={index}>
                      <img src={liheart} alt="heart-icon" />
                      <span>{item}</span>
                    </li>
                  ))}
                </ul>
              </div>
              <div className="wrap_right">
                <figure>
                  <img src={detail?.howToReduce?.image} alt="image" />
                </figure>
              </div>
            </div>
          </div>
        </section>
        {/* <section className="expert_sec">
          <div className="container">
            <div className="page_title">
              <h2>Download the App to Start Healing Journey</h2>
              <div className="btn-box">
                <Link to="/login" className="button blue">
                  Download the app
                </Link>
              </div>
            </div>
          </div>
        </section> */}

        {/* FAQ */}
        <FAQ type={"menopause"} />
      </div>
    </>
  );
};

export default Menopause;
